import React from 'react';

const CardContainer = ({ children, heading, desc }) => {
   
    return (
        <>
            <div className='container'>
                <div className='mb-5'>
                    <h1 className='fw-bold mb-3'>
                        {heading || "Card Container"}
                    </h1>
                    <p>{desc || "Card container is a wrapper of different cards."}</p>
                </div>
                <div className={`row row-cols-1 row-cols-md-2 row-cols-lg-3 ${children?.length>3 && "row-cols-xxl-4"} row-gap-4`}>
                    {children}
                </div>
            </div>
        </>
    )
}

export default CardContainer